import { render } from "./RPT_CodigoQR.vue?vue&type=template&id=674523a6"
import script from "./RPT_CodigoQR.vue?vue&type=script&lang=js"
export * from "./RPT_CodigoQR.vue?vue&type=script&lang=js"

import exportComponent from "C:\\vue\\evangelio-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__